import keys from 'constants/keys'
import { resolveLiteral } from './localeText'

export const getLanguageName = (locale: string, dictionary?: Partial<Record<string, string>>) =>
  resolveLiteral({ value: 'language_name', fallback: keys.LOCALE_MAP[locale] || locale }, dictionary).trim()
